<template>
  <Card class="map-card1">
    <div class="text-xs-center pt-3 pb-3">MAIN BATTERIES</div>
    <v-divider class="custom-divider" />
    <div class="mt-2 text-xs-center">
      <v-layout v-if="!showCarousel" row wrap justify-center align-center fill-height class="px-3 py-2">
        <v-flex v-for="(item, id) in mainBatteryList" :key="id" xs12 sm10 :md6="batteryCount === 2"
          :md9="batteryCount === 1" class="px-2">
          <MainBatteryItem :item="item" @click="onCardClick(id)" style="width: 100%" />
        </v-flex>
      </v-layout>

      <v-carousel v-else class="transparent-carousel" hide-delimiters height="100%" :cycle="true">
        <v-carousel-item v-for="(item, id) in mainBatteryList" :key="id">
          <v-layout row wrap justify-center align-center fill-height class="px-4 py-2">
            <v-flex xs12 sm10 md9>
              <MainBatteryItem :item="item" @click="onCardClick(id)" style="width: 100%" />
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </div>
  </Card>
</template>

<script>
import MainBatteryItem from './MainBatteryItem.vue';

export default {
  name: "MainBatteriesCard",
  components: {
    MainBatteryItem,
  },
  props: {
    mainBatteryList: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    batteryCount() {
      return Object.keys(this.mainBatteryList || {}).length;
    },
    showCarousel() {
      return this.batteryCount > 2;
    }
  },
  methods: {
    onCardClick(id) {
      this.$emit("show-sub-battery", id);
    },
  },
};
</script>

<style scoped>
.map-card1 {
  height: auto;
  border: 1px solid #334079 !important;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

@media only screen and (min-width: 1904px) {
  .map-card1 {
    height: 464px;
  }
}

.custom-divider {
  border-color: #334079 !important;
}

.transparent-carousel {
  border: none;
  box-shadow: none;
}
</style>
